import { SET_USER_VALUE } from "../constant";

export const setUserValue = (objValues) => ({
  type: SET_USER_VALUE,
  payload: objValues,
});
